export const about = [
  {
    desc: "SnowMore Profesyonel Kayak Kulübü, kayak sporunu Türkiye ve yurtdışında, dünyanın en gözde lokasyonlarında, alanında uzman eğitmen kadrosu ile kayak ve yarış okulu eğitimleri düzenleyen bir profesyonel spor kuruluşudur. Amacımız, her yaştan kayak severlere hem eğlenceli hem de öğretici bir deneyim sunarak, spora olan ilgilerini artırmak ve yeteneklerini geliştirmektir. SnowMore, kayak sporunu en üst düzeyde öğretirken, katılımcılarına unutulmaz bir deneyim yaşatmayı hedeflemektedir.",
    cover: "./images/logo.png",
  },
];

const campSchedule = [
  {
    id: 1,
    cover: "/images/camps/kampbir.jpg",
    name: "JoyWhite Kayak Kulübü",
    Location: "Sarıkamış/Kars",
    BeginDate: "17 Aralık",
    EndDate: "20 Aralık 2026",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "78.180,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "117.048,00 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "91.284,00 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "138.888,00 ₺" },
      ],
    },
    description:
      "Kışın büyüsünü keşfetmek için JoyWhite Kayak Eğitimi'ne katılın! Profesyonel kayak eğitmenlerimiz eşliğinde, çocuklarınız güvenli bir ortamda kayak öğrenirken, eğlenceli aktivitelerle dolu bir tatil geçirecekler.",
  },
  {
    id: 2,
    cover: "/images/camps/joywhite-camp1.jpg",
    name: "JoyWhite Kayak Kulübü",
    Location: "Sarıkamış/Kars",
    BeginDate: "24 Aralık",
    EndDate: "27 Aralık 2026",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "81.540,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "130.152,00 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "95.652,00 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "144.264,00 ₺" },
      ],
    },
    description:
      "Çocuklarınızın kış tatilini unutulmaz kılmak için JoyWhite Kayak Eğitimi'ne davet ediyoruz! Kayak dersleri, oyunlar ve doğa yürüyüşleri ile dolu bu eğitim, çocuklarınızın hem öğrenmesini hem de eğlenmesini sağlayacak.",
  },
  {
    id: 3,
    cover: "/images/camps/kampuc.jpg",
    name: "JoyWhite Kayak Kulübü",
    badge: "Yılbaşı Özel",
    Location: "Sarıkamış/Kars",
    BeginDate: "31 Aralık 2026",
    EndDate: "3 Ocak 2027",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "92.964,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "145.003,20 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "110.503,20 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "162.542,40 ₺" },
      ],
    },
    description:
      "Yılbaşı hafta sonunu karların arasında geçirin! Çocuklarınız güvenli bir ortamda kayak yaparken, yeni yıla eğlenceli aktivitelerle dolu özel bir kamp deneyimiyle merhaba diyecek.",
  },
  {
    id: 4,
    cover: "/images/camps/kampdort.jpg",
    name: "JoyWhite Kayak Kulübü",
    Location: "Sarıkamış/Kars",
    BeginDate: "7 Ocak",
    EndDate: "10 Ocak 2027",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "85.572,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "135.393,60 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "100.893,60 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "150.715,20 ₺" },
      ],
    },
    description:
      "JoyWhite Kayak Eğitimi, çocuklarınızın kış tatilini eğlenceli ve öğretici bir deneyime dönüştürüyor! Karlarla dolu bu eğitim, doğa ile iç içe, harika anılar biriktirecekleri bir fırsat sunuyor.",
  },
  {
    id: 5,
    cover: "/images/camps/kampbes.jpg",
    name: "JoyWhite Kayak Kulübü",
    badge: "Sömestr Öncesi",
    Location: "Sarıkamış/Kars",
    BeginDate: "21 Ocak",
    EndDate: "24 Ocak 2027",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "85.572,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "135.393,60 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "100.893,60 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "150.715,20 ₺" },
      ],
    },
    description:
      "Sömestr tatiline girmeden önce çocuklarınız için keyifli bir kış molası! Deneyimli eğitmenlerimiz eşliğinde güvenli bir ortamda kayak öğrenirken eğlenceli aktivitelerle dolu günler geçirecekler.",
  },
  {
    id: 6,
    cover: "/images/camps/kampalti.jpg",
    name: "JoyWhite Kayak Kulübü",
    badge: "4 Gün",
    Location: "Sarıkamış/Kars",
    BeginDate: "24 Ocak",
    EndDate: "27 Ocak 2027",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "99.684,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "153.739,20 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "119.239,20 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "173.294,40 ₺" },
      ],
    },
    description:
      "Sömestr tatiline özel 4 günlük kamp! Çocuklarınız, uzman eğitmenlerimiz eşliğinde kayak becerilerini geliştirirken, tatilin keyfini eşsiz doğada çıkaracak.",
  },
  {
    id: 7,
    cover: "/images/camps/joywhite-camp2.jpg",
    name: "JoyWhite Kayak Kulübü",
    badge: "4 Gün",
    Location: "Sarıkamış/Kars",
    BeginDate: "28 Ocak",
    EndDate: "31 Ocak 2027",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "106.404,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "162.475,20 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "127.975,20 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "184.046,40 ₺" },
      ],
    },
    description:
      "Sömestr tatiline özel 4 günlük bir başka kamp dönemi! Kayak dersleri, grup oyunları ve eğlenceli etkinliklerle dolu bu eğitim, çocuklarınızın hem öğrenmesini hem de eğlenmesini sağlayacak.",
  },
  {
    id: 8,
    cover: "/images/camps/kampbir.jpg",
    name: "JoyWhite Kayak Kulübü",
    badge: "4 Gün",
    Location: "Sarıkamış/Kars",
    BeginDate: "31 Ocak",
    EndDate: "3 Şubat 2027",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "106.404,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "162.475,20 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "127.975,20 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "184.046,40 ₺" },
      ],
    },
    description:
      "Sömestr tatili kapsamındaki 4 günlük kamplarımızdan bir diğeri. Güvenli bir kayak öğrenme ortamı sunan profesyonel ekibimiz, çocuklarınızın hem eğlenmesini hem de yeteneklerini geliştirmesini sağlıyor.",
  },
  {
    id: 9,
    cover: "/images/camps/Kampiki.jpg",
    name: "JoyWhite Kayak Kulübü",
    badge: "4 Gün",
    Location: "Sarıkamış/Kars",
    BeginDate: "4 Şubat",
    EndDate: "7 Şubat 2027",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "106.404,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "162.475,20 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "127.975,20 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "184.046,40 ₺" },
      ],
    },
    description:
      "Sömestr tatili döneminin son 4 günlük özel kampı. Kar ve doğa ile iç içe geçen bu eğitim, yeni arkadaşlıkların kurulmasına ve becerilerin gelişmesine olanak tanıyacak.",
  },
  {
    id: 10,
    cover: "/images/camps/kampuc.jpg",
    name: "JoyWhite Kayak Kulübü",
    badge: "Sömestr Sonrası",
    Location: "Sarıkamış/Kars",
    BeginDate: "11 Şubat",
    EndDate: "14 Şubat 2027",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "93.636,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "145.876,80 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "111.376,80 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "163.617,60 ₺" },
      ],
    },
    description:
      "Sömestr tatilinin ardından ilk kamp dönemimiz! Uzman eğitmenlerimiz eşliğinde çocuklarınız güvenli bir ortamda kayak öğrenirken eğlenceli aktivitelerle dolu bir tatil geçirecekler.",
  },
  {
    id: 11,
    cover: "/images/camps/kampdort.jpg",
    name: "JoyWhite Kayak Kulübü",
    Location: "Sarıkamış/Kars",
    BeginDate: "18 Şubat",
    EndDate: "21 Şubat 2027",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "93.636,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "145.876,80 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "111.376,80 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "163.617,60 ₺" },
      ],
    },
    description:
      "JoyWhite Kayak Eğitimi, kışın sunduğu eğlenceleri çocuklarınız için özel bir deneyime dönüştürüyor! Uzman ekibimiz, güvenliği ön planda tutarak kayak becerilerini geliştirmelerine yardımcı olacak.",
  },
  {
    id: 12,
    cover: "/images/camps/joywhite-camp3.jpg",
    name: "JoyWhite Kayak Kulübü",
    Location: "Sarıkamış/Kars",
    BeginDate: "25 Şubat",
    EndDate: "28 Şubat 2027",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "93.636,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "145.876,80 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "111.376,80 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "163.617,60 ₺" },
      ],
    },
    description:
      "Kış tatilinizi daha eğlenceli hale getirmek için JoyWhite Kayak Eğitimi'ne katılın! Profesyonel eğitmenlerimiz eşliğinde çocuklarınız, kayak yapmanın keyfini güvenli bir ortamda çıkaracak.",
  },
  {
    id: 13,
    cover: "/images/camps/kampalti.jpg",
    name: "JoyWhite Kayak Kulübü",
    badge: "Ara Tatil Öncesi",
    Location: "Sarıkamış/Kars",
    BeginDate: "4 Mart",
    EndDate: "7 Mart 2027",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "93.636,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "145.876,80 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "111.376,80 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "163.617,60 ₺" },
      ],
    },
    description:
      "Ara tatile girmeden önce son standart kamp dönemimiz. Çocuklarınız, deneyimli kayak eğitmenlerimizin rehberliğinde güvenli bir ortamda kayak yapmanın tadını çıkaracak.",
  },
  {
    id: 14,
    cover: "/images/camps/kampyedi.jpg",
    name: "JoyWhite Kayak Kulübü",
    badge: "Ramazan Bayramı",
    Location: "Sarıkamış/Kars",
    BeginDate: "7 Mart",
    EndDate: "10 Mart 2027",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "93.636,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "145.876,80 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "111.376,80 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "163.617,60 ₺" },
      ],
    },
    description:
      "Ara tatil ve Ramazan Bayramı'na özel ilk kamp dönemi. Bayram tatilini karların arasında, kayak ve eğlenceli aktivitelerle dolu geçirin.",
  },
  {
    id: 15,
    cover: "/images/camps/kampbir.jpg",
    name: "JoyWhite Kayak Kulübü",
    badge: "Ramazan Bayramı",
    Location: "Sarıkamış/Kars",
    BeginDate: "11 Mart",
    EndDate: "14 Mart 2027",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "96.324,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "149.371,20 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "114.871,20 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "167.918,40 ₺" },
      ],
    },
    description:
      "Ara tatil ve Ramazan Bayramı kapsamındaki ikinci kamp dönemimiz. Eğlenceli etkinlikler ve grup oyunlarıyla dolu bu eğitim, yeni arkadaşlıkların kurulmasına olanak tanıyacak.",
  },
  {
    id: 16,
    cover: "/images/camps/Kampiki.jpg",
    name: "JoyWhite Kayak Kulübü",
    badge: "Ara Tatil Sonrası",
    Location: "Sarıkamış/Kars",
    BeginDate: "18 Mart",
    EndDate: "21 Mart 2027",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "81.540,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "120.744,00 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "95.652,00 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "144.264,00 ₺" },
      ],
    },
    description:
      "Ara tatilin ardından ilk kamp dönemimiz. Çocuklarınız güvenli bir ortamda kayak öğrenirken, kışın keyfini çıkarıp yeni arkadaşlıklar kuracaklar.",
  },
  {
    id: 17,
    cover: "/images/camps/joywhite-camp1.jpg",
    name: "JoyWhite Kayak Kulübü",
    badge: "Sezon Kapanışı",
    Location: "Sarıkamış/Kars",
    BeginDate: "25 Mart",
    EndDate: "28 Mart 2027",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "81.540,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "120.744,00 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "95.652,00 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "144.264,00 ₺" },
      ],
    },
    description:
      "1 Nisan öncesi sezonun son kamp dönemi! Kış sezonunu kayak, eğlence ve unutulmaz anılarla kapatın.",
  },
];

const erganSchedule = [
  {
    id: 1,
    cover: "/images/camps/kampbir.jpg",
    name: "JoyWhite Kayak Kulübü",
    badge: "Yılbaşı Özel",
    Location: "Ergan Dağı/Erzincan",
    BeginDate: "31 Aralık 2026",
    EndDate: "3 Ocak 2027",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "105.100,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "118.300,00 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "123.580,00 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "136.780,00 ₺" },
      ],
    },
    description:
      "Yılbaşı hafta sonunu Ergan Dağı'nın karlı zirvelerinde geçirin! Çocuklarınız güvenli bir ortamda kayak yaparken, yeni yıla eğlenceli aktivitelerle dolu özel bir kamp deneyimiyle merhaba diyecek.",
  },
  {
    id: 2,
    cover: "/images/camps/joywhite-camp1.jpg",
    name: "JoyWhite Kayak Kulübü",
    Location: "Ergan Dağı/Erzincan",
    BeginDate: "7 Ocak",
    EndDate: "10 Ocak 2027",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "110.380,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "123.580,00 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "131.500,00 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "144.700,00 ₺" },
      ],
    },
    description:
      "JoyWhite Kayak Eğitimi, Ergan Dağı'nın geniş pistlerinde çocuklarınızın kış tatilini eğlenceli ve öğretici bir deneyime dönüştürüyor!",
  },
  {
    id: 3,
    cover: "/images/camps/kampuc.jpg",
    name: "JoyWhite Kayak Kulübü",
    Location: "Ergan Dağı/Erzincan",
    BeginDate: "14 Ocak",
    EndDate: "17 Ocak 2027",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "110.380,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "123.580,00 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "131.500,00 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "144.700,00 ₺" },
      ],
    },
    description:
      "Çocuklarınızın kış tatilini unutulmaz kılmak için Ergan Dağı'ndaki JoyWhite Kayak Eğitimi'ne davet ediyoruz! Kayak dersleri, oyunlar ve doğa yürüyüşleri ile dolu bu eğitim keyifli anılar biriktirecek.",
  },
  {
    id: 4,
    cover: "/images/camps/kampdort.jpg",
    name: "JoyWhite Kayak Kulübü",
    badge: "Sömestr Öncesi",
    Location: "Ergan Dağı/Erzincan",
    BeginDate: "21 Ocak",
    EndDate: "24 Ocak 2027",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "115.660,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "128.860,00 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "140.300,00 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "153.500,00 ₺" },
      ],
    },
    description:
      "Sömestr tatiline girmeden önce çocuklarınız için Ergan Dağı'nda keyifli bir kış molası! Deneyimli eğitmenlerimiz eşliğinde güvenli bir ortamda kayak öğrenirken eğlenceli günler geçirecekler.",
  },
  {
    id: 5,
    cover: "/images/camps/kampbes.jpg",
    name: "JoyWhite Kayak Kulübü",
    Location: "Ergan Dağı/Erzincan",
    BeginDate: "28 Ocak",
    EndDate: "31 Ocak 2027",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "118.300,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "131.500,00 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "144.700,00 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "157.900,00 ₺" },
      ],
    },
    description:
      "Sömestr tatili dönemindeki kamplarımızdan biri. Çocuklarınız, uzman eğitmenlerimiz eşliğinde kayak becerilerini geliştirirken, Ergan Dağı'nın eşsiz doğasının keyfini çıkaracak.",
  },
  {
    id: 6,
    cover: "/images/camps/kampalti.jpg",
    name: "JoyWhite Kayak Kulübü",
    Location: "Ergan Dağı/Erzincan",
    BeginDate: "31 Ocak",
    EndDate: "3 Şubat 2027",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "118.300,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "131.500,00 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "144.700,00 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "157.900,00 ₺" },
      ],
    },
    description:
      "Sömestr tatiline özel bir diğer kamp dönemi. Kayak dersleri, grup oyunları ve eğlenceli etkinliklerle dolu bu eğitim, çocuklarınızın hem öğrenmesini hem de eğlenmesini sağlayacak.",
  },
  {
    id: 7,
    cover: "/images/camps/joywhite-camp2.jpg",
    name: "JoyWhite Kayak Kulübü",
    Location: "Ergan Dağı/Erzincan",
    BeginDate: "4 Şubat",
    EndDate: "7 Şubat 2027",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "118.300,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "131.500,00 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "144.700,00 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "157.900,00 ₺" },
      ],
    },
    description:
      "Sömestr tatili kapsamındaki kamplarımızdan bir diğeri. Güvenli bir kayak öğrenme ortamı sunan profesyonel ekibimiz, çocuklarınızın hem eğlenmesini hem de yeteneklerini geliştirmesini sağlıyor.",
  },
  {
    id: 8,
    cover: "/images/camps/Kampiki.jpg",
    name: "JoyWhite Kayak Kulübü",
    badge: "Sömestr Sonrası",
    Location: "Ergan Dağı/Erzincan",
    BeginDate: "11 Şubat",
    EndDate: "14 Şubat 2027",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "93.220,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "106.420,00 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "109.060,00 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "122.260,00 ₺" },
      ],
    },
    description:
      "Sömestr tatilinin ardından ilk kamp dönemimiz! Uzman eğitmenlerimiz eşliğinde çocuklarınız Ergan Dağı'nda güvenli bir ortamda kayak öğrenirken eğlenceli aktivitelerle dolu bir tatil geçirecekler.",
  },
  {
    id: 9,
    cover: "/images/camps/kampyedi.jpg",
    name: "JoyWhite Kayak Kulübü",
    Location: "Ergan Dağı/Erzincan",
    BeginDate: "18 Şubat",
    EndDate: "21 Şubat 2027",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "93.220,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "106.420,00 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "109.060,00 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "122.260,00 ₺" },
      ],
    },
    description:
      "JoyWhite Kayak Eğitimi, kışın sunduğu eğlenceleri çocuklarınız için Ergan Dağı'nda özel bir deneyime dönüştürüyor! Uzman ekibimiz, güvenliği ön planda tutarak kayak becerilerini geliştirmelerine yardımcı olacak.",
  },
  {
    id: 10,
    cover: "/images/camps/joywhite-camp3.jpg",
    name: "JoyWhite Kayak Kulübü",
    Location: "Ergan Dağı/Erzincan",
    BeginDate: "25 Şubat",
    EndDate: "28 Şubat 2027",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "93.220,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "106.420,00 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "109.060,00 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "122.260,00 ₺" },
      ],
    },
    description:
      "Kış tatilinizi daha eğlenceli hale getirmek için Ergan Dağı'ndaki JoyWhite Kayak Eğitimi'ne katılın! Profesyonel eğitmenlerimiz eşliğinde çocuklarınız, kayak yapmanın keyfini güvenli bir ortamda çıkaracak.",
  },
  {
    id: 11,
    cover: "/images/camps/kampbir.jpg",
    name: "JoyWhite Kayak Kulübü",
    badge: "Ara Tatil Öncesi",
    Location: "Ergan Dağı/Erzincan",
    BeginDate: "4 Mart",
    EndDate: "7 Mart 2027",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "109.940,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "123.140,00 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "132.820,00 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "146.020,00 ₺" },
      ],
    },
    description:
      "Ara tatile girmeden önce son standart kamp dönemimiz. Çocuklarınız, deneyimli kayak eğitmenlerimizin rehberliğinde Ergan Dağı'nda güvenli bir ortamda kayak yapmanın tadını çıkaracak.",
  },
  {
    id: 12,
    cover: "/images/camps/joywhite-camp1.jpg",
    name: "JoyWhite Kayak Kulübü",
    badge: "Ramazan Bayramı",
    Location: "Ergan Dağı/Erzincan",
    BeginDate: "7 Mart",
    EndDate: "10 Mart 2027",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "118.300,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "131.500,00 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "144.700,00 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "157.900,00 ₺" },
      ],
    },
    description:
      "Ara tatil ve Ramazan Bayramı'na özel ilk kamp dönemi. Bayram tatilini Ergan Dağı'nın karları arasında, kayak ve eğlenceli aktivitelerle dolu geçirin.",
  },
  {
    id: 13,
    cover: "/images/camps/kampuc.jpg",
    name: "JoyWhite Kayak Kulübü",
    badge: "Ramazan Bayramı",
    Location: "Ergan Dağı/Erzincan",
    BeginDate: "11 Mart",
    EndDate: "14 Mart 2027",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "118.300,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "131.500,00 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "144.700,00 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "157.900,00 ₺" },
      ],
    },
    description:
      "Ara tatil ve Ramazan Bayramı kapsamındaki ikinci kamp dönemimiz. Eğlenceli etkinlikler ve grup oyunlarıyla dolu bu eğitim, yeni arkadaşlıkların kurulmasına olanak tanıyacak.",
  },
  {
    id: 14,
    cover: "/images/camps/kampdort.jpg",
    name: "JoyWhite Kayak Kulübü",
    badge: "Ara Tatil Sonrası",
    Location: "Ergan Dağı/Erzincan",
    BeginDate: "18 Mart",
    EndDate: "21 Mart 2027",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "105.100,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "118.300,00 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "123.580,00 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "136.780,00 ₺" },
      ],
    },
    description:
      "Ara tatilin ardından ilk kamp dönemimiz. Çocuklarınız Ergan Dağı'nda güvenli bir ortamda kayak öğrenirken, kışın keyfini çıkarıp yeni arkadaşlıklar kuracaklar.",
  },
  {
    id: 15,
    cover: "/images/camps/kampbes.jpg",
    name: "JoyWhite Kayak Kulübü",
    badge: "Sezon Kapanışı",
    Location: "Ergan Dağı/Erzincan",
    BeginDate: "25 Mart",
    EndDate: "28 Mart 2027",
    Price: {
      adultChildCombination: [
        { type: "1 Yetişkin 1 Çocuk", price: "105.100,00 ₺" },
        { type: "1 Yetişkin 2 Çocuk", price: "118.300,00 ₺" },
        { type: "2 Yetişkin 1 Çocuk", price: "123.580,00 ₺" },
        { type: "2 Yetişkin 2 Çocuk", price: "136.780,00 ₺" },
      ],
    },
    description:
      "1 Nisan öncesi sezonun son kamp dönemi! Kış sezonunu Ergan Dağı'nda kayak, eğlence ve unutulmaz anılarla kapatın.",
  },
];

export const campLocations = [
  {
    key: "sarikamis",
    name: "Sarıkamış",
    fullLocation: "Sarıkamış/Kars",
    cover: "/images/staticImages/hero-2.jpg",
    intro:
      "Kars'ın saklı cenneti Sarıkamış'ta, kristal kar yapısına sahip pistlerde çocuklarınız için profesyonel kayak eğitimi.",
    crystalSnowBlurb:
      "Sarıkamış, Alpler'de görülen kristal kar yapısına sahip Türkiye'deki nadir kayak merkezlerinden biridir.",
    pisteInfoTitle: "Sarıkamış Pistleri Hakkında",
    pisteInfo: [
      "Kars-Sarıkamış; Bayraktepe Kayak Merkezi ve pistleri bölgeye özgü sarıçam ormanlarının içindedir.",
      "Rakımı 2200-2600 metre yükseklikteki kayak merkezi Kars hava alanına 40 dakikadır.",
      "Sarıçamlar arasındaki pistlerde 1,5 metreye ulaşan kar kalınlığı bölgede uzun bir sezonda kayak yapma olanağı sunmaktadır.",
      "Özellikle “kristal” şeklinde yağan kar Alplerdeki pudra kar niteliği ile kayak sevenlerin tutkusu haline gelmiştir.",
    ],
  },
  {
    key: "ergan",
    name: "Ergan Dağı",
    fullLocation: "Ergan Dağı/Erzincan",
    cover: "/images/staticImages/hero-4.jpg",
    intro:
      "Erzincan'ın gözbebeği Ergan Dağı'nda, geniş pistler ve eşsiz doğayla çocuklarınız için profesyonel kayak eğitimi.",
    crystalSnowBlurb:
      "Ergan Dağı, geniş pistleri ve bol kar örtüsüyle Doğu Anadolu'nun öne çıkan kayak merkezlerinden biridir.",
    pisteInfoTitle: "Ergan Dağı Pistleri Hakkında",
    pisteInfo: [
      "Erzincan Ergan Dağı Kayak Merkezi, geniş pistleriyle her seviyeden kayakçıya uygun imkanlar sunar.",
      "Bölge, kış sezonu boyunca kalıcı kar örtüsüne sahip olup kayak sezonunu uzun tutar.",
      "Doğal yapısıyla çocuklar için güvenli ve ferah bir eğitim ortamı sağlar.",
      "Eğitmen kadromuz aynı özenle Ergan Dağı'ndaki kamplarımızda da görev almaktadır.",
    ],
  },
];

const schedulesByLocation = {
  sarikamis: campSchedule,
  ergan: erganSchedule,
};

export const campsDataByLocation = Object.fromEntries(
  campLocations.map((location) => [
    location.key,
    schedulesByLocation[location.key].map((camp) => ({
      ...camp,
      id: location.key === "sarikamis" ? camp.id : camp.id + 100,
      Location: location.fullLocation,
      locationKey: location.key,
    })),
  ])
);

export const campsData = Object.values(campsDataByLocation).flat();

export const blog = [
  {
    id: 1,
    title: "Master These Awesome",
    date: "Jun 27, 2022",
    author: "Dorian Gray",
    desc: "Lorem Ipsum has been standard. Lorem Ipsum is simply text of the printing and typesetting industry. Lorem Ipsum has been",
    cover: "./images/blog/b1.png",
  },
  {
    id: 2,
    title: "Best Design Items to Appeal",
    date: "Jun 27, 2022",
    author: "Dorian Gray",
    desc: "Lorem Ipsum has been standard. Lorem Ipsum is simply text of the printing and typesetting industry. Lorem Ipsum has been",
    cover: "./images/blog/b2.png",
  },
  {
    id: 3,
    title: "The 20 Best Lightroom Presets",
    date: "Jun 27, 2022",
    author: "Dorian Gray",
    desc: "Lorem Ipsum has been standard. Lorem Ipsum is simply text of the printing and typesetting industry. Lorem Ipsum has been",
    cover: "./images/blog/b3.png",
  },
];

export const fotos = [
  {
    id: 1,
    src: "/images/camps/ornekResim.jpg",
  },
  {
    id: 2,
    src: "/images/camps/ornekResim.jpg",
  },
  {
    id: 3,
    src: "/images/camps/ornekResim.jpg",
  },
  {
    id: 4,
    src: "/images/camps/ornekResim.jpg",
  },
  {
    id: 5,
    src: "/images/camps/ornekResim.jpg",
  },
  {
    id: 6,
    src: "/images/camps/ornekResim.jpg",
  },
  {
    id: 7,
    src: "/images/camps/ornekResim.jpg",
  },
  {
    id: 8,
    src: "/images/camps/ornekResim.jpg",
  },
  {
    id: 9,
    src: "/images/camps/ornekResim.jpg",
  },
  {
    id: 10,
    src: "/images/camps/ornekResim.jpg",
  },
  {
    id: 11,
    src: "/images/camps/ornekResim.jpg",
  },
  {
    id: 12,
    src: "/images/camps/ornekResim.jpg",
  },
  {
    id: 13,
    src: "/images/camps/ornekResim.jpg",
  },
];
